import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

/**
 * Provides the selection and save logic needed by the actFileUpload directive
 */
export class FileUploadController {
  public static $inject = ['UserMessages', '$translate', '$scope'];

  public uploadObject: any;
  public isUploaderDisabled: boolean;
  public allowedFileTypes: string;
  public errorMessage: string;
  public onFileImported: Function;
  public autoUpload: Function;
  private listOfAcceptableExtensions: Array<string>;
  private showSubErrorMessage: boolean;

  constructor(protected UserMessages: UserMessagesService, protected $translate: ng.translate.ITranslateService, $scope) {
    // tslint:disable-next-line: forin
    for (const propertyName in $scope.vm) {
      this[propertyName] = $scope.vm[propertyName];
    }

    if (!this.allowedFileTypes) {
      return;
    }

    this.listOfAcceptableExtensions = this.allowedFileTypes.split(',').map((extension) => {
      return extension.trim();
    });
  }

  /**
   * Checks if the file is unset
   *
   * @returns true when the file is undefined
   */
  public noFile = () => {
    return _.isUndefined(this.uploadObject.file);
  }

  /**
   * Sets the value of the file if extension is valid. Otherwise shows error dialog
   *
   * @param file The file we wish to check against
   */
  public upload = (file) => {
    this.errorMessage = undefined;
    if (_.isNull(file) || _.isUndefined(file)) {
      return;
    }

    const enteredFileExtension = '.' + file.name.split('.').pop();
    if (!_.includes(this.listOfAcceptableExtensions, enteredFileExtension)) {
      const errorMessage = this.$translate.instant('FILE_TYPE_NOT_RECOGNISED_MESSAGE', {
        types: this.allowedFileTypes
      });
      if (this.showSubErrorMessage) {
        this.errorMessage = errorMessage;
      } else {
        this.showError('FILE_TYPE_NOT_RECOGNISED', errorMessage);
      }
      return;
    }
    this.uploadObject.file = file;

    if (this.onFileImported) {
      this.onFileImported();
    }

    if (this.autoUpload) {
      this.autoUpload();
    }
  }

  protected showError(title: string, message: string) {
    this.UserMessages.showAlert(title, message);
  }
}